import { Accordion, Link, Stack, Text } from '@solvhealth/jigsaw-v1';
import React, { ReactNode } from 'react';
import { AlmaUrls } from '~/components/AccountGetsMarried/constants/alma';
import { analyticsTrackEvent } from '~/core/analytics';
import { ALMA_CLICK_FAQ } from '~/core/analytics/events';
import { NativeFunctions } from '~/core/util/native';

const faq: { question: string; answer: ReactNode }[] = [
  {
    question: 'What is Alma?',
    answer:
      'Alma is a diverse network of mental health care providers committed to offering the highest quality of care. Alma believes when therapists have the support they need, care gets better for everyone — allowing you to face life’s challenges and achieve lasting results.',
  },
  {
    question: 'What is Alma commonly used for?',
    answer: (
      <Stack justifyContent="space-between" row space={1}>
        <Stack>
          <Text muted>Addictions</Text>
          <Text muted>Anxiety</Text>
          <Text muted>Depression</Text>
          <Text muted>Grief &amp; loss</Text>
          <Text muted>Life transitions</Text>
        </Stack>
        <Stack>
          <Text muted>Sex & intimacy</Text>
          <Text muted>Stress</Text>
          <Text muted>Trauma</Text>
          <Text muted>Personal growth</Text>
        </Stack>
      </Stack>
    ),
  },
  {
    question: 'What types of payment does Alma accept?',
    answer: (
      <Text as="div">
        Most therapists at Alma accept insurance from major companies like Aetna, Cigna, Optum, and
        more. To see how much your insurance covers and what you’ll owe per session, use{' '}
        <Link
          contentProps={{
            style: {
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              display: 'inline',
            },
          }}
          external
          href={AlmaUrls.costEstimator}
          onClick={(e: any) => {
            if (NativeFunctions.openNativeUrl.exists) {
              e.preventDefault();
              NativeFunctions.openNativeUrl.call(AlmaUrls.costEstimator);
            }
          }}
          openInNewWindow
          sx={{
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            display: 'inline',
          }}
        >
          Alma’s cost estimator
        </Link>
        . Out-of-pocket options are also available, including sliding scale rates based on your
        income.
      </Text>
    ),
  },
  {
    question: 'How will Alma help me find a therapist?',
    answer:
      'Alma’s directory is free and easy to use. Whether you know exactly what you’re looking for or need a little help, the directory will guide you to someone who meets your needs.',
  },
  {
    question: 'How do I know which therapist is right for me?',
    answer:
      'Therapy is more impactful when you feel safe and understood  — which is why we care so much about finding you the right fit. Alma’s directory lets you search by gender, race, specialty, therapeutic style, type of care (talk therapy or medication management), and more. Most therapists also offer free, 15-minute consultations, so you can explore all your options before you decide.',
  },
  {
    question: 'How often will I meet with my therapist?',
    answer:
      'It’s up to you! Many people prefer to start with weekly sessions, but you can set a cadence that feels right to you and your therapist. ',
  },
];

export function AlmaFaq() {
  return (
    <Stack id="faq" px={3} space={3}>
      <Text variant="h3">Alma FAQs</Text>
      {faq.map((item) => (
        <Accordion
          accordionVariant="body1"
          body={item.answer}
          key={item.question}
          onClick={() => {
            analyticsTrackEvent(ALMA_CLICK_FAQ, {
              question: item.question,
            });
          }}
          title={item.question}
        />
      ))}
    </Stack>
  );
}
